import { get } from "../apiClient";

export async function getFavs() {
  const response = await get(`/user/favorites`, "wl-logostore-tester");
  // console.log('response',response);

  if (!response.success) {
    const err = await JSON.parse(JSON.stringify(response));
    throw err.message ?? "An error occurred";
  }

  const json = await JSON.parse(JSON.stringify(response));

  if (json.data == null) {
    return null;
  }

  return json;
}
